import { Box, Heading, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { getPostList } from '../../../service';
import ParticipationContentItemSciforumView from './ParticipationContentItemSciforumView';

function ParticipationContentItemSciforum() {
  const [currentItemIndex, setCurrentItemIndex] = useState(0);

  const { isLoading, error, data } = useQuery('ParticipationContentItemSciforum', () => getPostList('sciforum'));

  const onMovePost = (value: number) => {		
    let nextPostIndex = currentItemIndex + value;
    if (nextPostIndex < 0) {
      nextPostIndex = 0;
    }
    if (nextPostIndex >= data.length) {
      nextPostIndex = data.length - 1;
    }
    setCurrentItemIndex(nextPostIndex);
  }

  useEffect(() => {
    if (data && window?.location.pathname.split('post=')[1]) {
      const c = data.findIndex((item: any) => item.slug === window?.location.pathname.split('post=')[1]);
      setCurrentItemIndex(c);
    }   
  }, [data])

  return (
    <>
    {
      !isLoading && !error && data && (
        <>
        <Box pt="6" pb="20">
          <Heading size="3xl" color="b.dgr" pb="8">{data[currentItemIndex].title} 환경학술포럼</Heading>
          <Text fontSize="lg" dangerouslySetInnerHTML={ {__html: data[currentItemIndex]?.meta?.sciforum_general_info } } />
        </Box>
        <ParticipationContentItemSciforumView post={data[currentItemIndex]} movePost={onMovePost} />
        </>
      )
    }
    </>
  );
}

export default ParticipationContentItemSciforum;
